import {
  GET_PMCS,
  GET_WEB_BASIC,
  GET_WEB_DETAILED
} from '../constants/onlineSales';
import {
  fetchPmcs,
  fetchWebBasic,
  fetchWebDetailed,
  updatePmcs
} from '../api/onlineSales';

export const getWebBasic = (wine, market) => async (dispatch) => {
  const data = await fetchWebBasic(wine, market);
  dispatch({
    type: GET_WEB_BASIC,
    payload: data
  });
};

export const getWebDetailed = (vintage, wine, market) => async (dispatch) => {
  const data = await fetchWebDetailed(vintage, wine, market);
  dispatch({
    type: GET_WEB_DETAILED,
    payload: data
  });
};

export const getPmcs = () => async (dispatch) => {
  const data = await fetchPmcs();

  dispatch({
    type: GET_PMCS,
    payload: data
  });
};

export const postPmcs = (data) => async (dispatch) => {
  await updatePmcs(data);
  const newData = await fetchPmcs();

  dispatch({
    type: GET_PMCS,
    payload: newData
  });
};
